import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { contactSupport } from '../actions/ui'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import Dropdown from './Dropdown'
import UserUtils from '../lib/UserUtils'
import Icon from './Icon'

@connect(null, {contactSupport})
export default class SiteNav extends Component {
  static propTypes = {
    site: PropTypes.object,
    url: PropTypes.string
  }

  onShowHelpModal = e => {
    e.preventDefault()
    this.props.contactSupport()
  }

  render () {
    const {site, url} = this.props

    const [,, section] = url.split('/')
    const contentClassName = cn({active: section === 'content' || section === 'settings'})
    const usersClassName = cn({active: section === 'users'})

    const canEditSite = UserUtils.can(site, 'update', 'site')

    return <div className='site-nav'>
      <div className='current-site'>
        <Dropdown label={site.name}>
          <div className='list-group'>
            {canEditSite &&
              <Link className='edit-site' to={`/${site.id}/edit`}>Settings</Link>
            }
            <a role='button' onClick={this.onShowHelpModal}>Help</a>
            <Link to='/logout'>Sign Out</Link>
          </div>
          <div className='list-group'>
            <Link className='dashboard-link' to='/dashboard'>
              <Icon name='ios-arrow-left' /> Dashboard
            </Link>
          </div>
        </Dropdown>
      </div>
      <nav>
        <Link to={`/${site.id}/content`} className={contentClassName}>Content</Link>
        <Link to={`/${site.id}/users`} className={usersClassName}>Users</Link>
      </nav>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/SiteNav.js